import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import {UNAUTHORIZED, BAD_REQUEST, FORBIDDEN, INTERNAL_SERVER_ERROR, NOT_FOUND} from 'http-status-codes';

import { LoggerService } from '../services/logger.service';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { appToaster } from '../../configs/app-toaster.config';
import { AuthenticationService } from '@authenticationService/authentication.service';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  
  constructor(
      private logger: LoggerService,
      private toasterService: ToastrService,
      private router: Router,
      private authenticationService: AuthenticationService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(error => this.errorHandler(error)));
  }
 
  private errorHandler(response: HttpEvent<any>): Observable<HttpEvent<any>> {
    if (!environment.production) {
      this.logger.logError('Request error ' + JSON.stringify(response));
    }

    let errMsg = "There is an error occurred, please try again later.";
    if (response['error']) errMsg = response['error'].error;
    else if (response['message']) errMsg = response['message'];

    let httpErrorCode = response['status'];

    if (errMsg == '401' || httpErrorCode == 0) {
      httpErrorCode = 401;
    }

    switch (httpErrorCode) {
      case UNAUTHORIZED:
        //relogin??

        

        this.authenticationService.logout().subscribe((res) => {
            let logOutURL = '/auth/login';
            this.toasterService.error('', "Session expired, please login again.");
            this.router.navigateByUrl(logOutURL);
          });
        break;
      case FORBIDDEN:
        this.router.navigateByUrl('/auth/403');
        break;
      case NOT_FOUND:
        this.router.navigateByUrl('/auth/404');
        break;
      case INTERNAL_SERVER_ERROR:
        if (response['error'] && response['error']['error']) this.toasterService.error(appToaster.errorHead, response['error']['error']);
        else this.toasterService.error(appToaster.errorHead, response['message']);
        break;
      default:
        this.toasterService.error(appToaster.errorHead, errMsg);
    }
    throw response;
  }

}

